const translations = {
    activeIngredients: 'Active Ingredients',
    addChemical: '+ Add Chemical',
    chemical: 'Chemical',
    chemicals: 'Chemicals',
    epaNumber: 'EPA Number',
    noChemicals: 'No chemicals assigned',
    notSet: 'Not set',
    pest: 'Pest',
    product: 'Product',
    productCountOne: '{count} product',
    productCountOther: '{count} products',
    rate: 'Rate',
    rateApplied: 'Rate Applied',
    removeChemical: 'Remove {title}',
    signalWord: 'Signal Word',
    unitFluidOuncesPerAcre: 'Fl. Oz/Ac',
    unitGallonsPerAcre: 'Ga/Ac',
    unitKilogramsPerSquareMeter: 'Kg/m²',
    unitOuncesPerAcre: 'Oz/Ac',
    unitPintsPerAcre: 'Pt/Ac',
    unitPoundsPerAcre: 'Lb/Ac',
    unitQuartsPerAcre: 'Qt/Ac'
};

export default translations;
